import { lazy } from "react";

// ============================================
// Layouts - EAGER (چون همیشه استفاده می‌شن)
// ============================================
import AuthLayout from "../components/partial/layouts/AuthLayout.js";
import MainLayout from "../components/partial/layouts/MainLayout.js";
import OwnerLayout from "../components/partial/layouts/OwnerLayout.js";
import AdminLayout from "../components/partial/layouts/AdminLayout.js";
import type { userRoleCartStreet } from "../lib/roles.js";
import CustomerImportCustomerExcelPage from "../pages/customer/services/revenues/customerImportExcelPage/index.js";
import ChangePassword from "../pages/customer/profiles/changePassword/index.js";
import CustomerTransactionsPage from "../pages/customer/transaction/index.js";
import ExcelFileListPage from "../pages/admin/excellUpload/list/index.js";
import ChangeAdminPasswordPage from "../pages/admin/changePassword/index.js";

// ============================================
// Auth Pages - LAZY
// ============================================
const SignUpCustomer = lazy(() => import("../pages/auth/signup/index.js"));
const Requlations = lazy(() => import("../pages/auth/requlations/index.js"));
const SelectRole = lazy(() => import("../pages/auth/selectRole/index.js"));
const LoginOrganizational = lazy(() => import("../pages/auth/loginOrganizational/index.js"));
const ForgetPassword = lazy(() => import("../pages/auth/loginOrganizational/forgaetPassword/index.js"));
const OtpOrganization = lazy(() => import("../pages/auth/loginOrganizational/otp/index.js"));
const ResetPassword = lazy(() => import("../pages/auth/loginOrganizational/resetPassword/index.js"));
const SignUpOrganization = lazy(() => import("../pages/auth/signUpOrganization/index.js"));
const RequestCardPage = lazy(() => import("../pages/auth/requestCardPage/index.js"));
const AccountOpening = lazy(() => import("../pages/auth/account-opening/index.js"));

// ============================================
// Customer Pages - LAZY
// ============================================
const MainCustomerPage = lazy(() => import("../pages/customer/mainPage/index.js"));
const CustomerRepots = lazy(() => import("../pages/customer/mainPage/repots/index.js"));
const CustomerProfile = lazy(() => import("../pages/customer/profiles/index.js"));
const CustomerQuestions = lazy(() => import("../pages/customer/profiles/Questions/index.js"));
const CustomerEditeProfile = lazy(() => import("../pages/customer/profiles/EditeProfile/index.js"));
const CustomerRule = lazy(() => import("../pages/customer/profiles/Rule/index.js"));
const CustomerAbouteUs = lazy(() => import("../pages/customer/profiles/About/index.js"));
const CustomerProfileTeach = lazy(() => import("../pages/customer/profiles/teach/index.js"));
const PlansListPage = lazy(() => import("../pages/customer/profiles/plan/index.js"));

// Customer Pos
const CustomerPos = lazy(() => import("../pages/customer/mainPage/pos/index.js"));
const CustomerPosDeviceSelect = lazy(() => import("../pages/customer/mainPage/pos/deviceSelect/index.js"));
const CustomerPosForm = lazy(() => import("../pages/customer/mainPage/pos/posForm/index.js"));
const ChangePosPage = lazy(() => import("../pages/customer/mainPage/pos/changePos/index.js"));

// Customer Cards
const CustomerCardRequestPill = lazy(() => import("../pages/customer/mainPage/customerCardRequestPill/index.js"));
const CustomerCardRequestGame = lazy(() => import("../pages/customer/mainPage/customerCardRequestGame/index.js"));
const CustomerCardRequestIncomeGeneration = lazy(() => import("../pages/customer/mainPage/customerCardReqeustIncomeGeneration/index.js"));
const CustomerCardRequesPillpaymentId = lazy(() => import("../pages/customer/mainPage/customerCardRequestPill/customerCardRequestPillId/index.js"));
const CustomerCardRequestPaymaneBuy = lazy(() => import("../pages/customer/mainPage/customerCardRequestPill/customerCardRequestPaymentBuy/index.js"));

// Customer Revenues
const CustomerRevenues = lazy(() => import("../pages/customer/services/revenues/index.js"));
const CustomerRevenuesCustomerReports = lazy(() => import("../pages/customer/services/revenues/customerReports/index.js"));
const CustomerRevenuesRegisterMarketerRequest = lazy(() => import("../pages/customer/services/revenues/registerMarketerRequest/index.js"));
const CustomerRevenuesRegisterVisitorRequest = lazy(() => import("../pages/customer/services/revenues/registerMarketerRequest/step2AdditionalInfo/index.js"));
const CustomerRevenuesAddCustomerBanking = lazy(() => import("../pages/customer/services/revenues/streetCartBank/index.js"));
const CustomerRevenuesRegisterAdditionalInfoBanking = lazy(() => import("../pages/customer/services/revenues/streetCartBank/step2DataBank/index.js"));
const CustomerRevenuesRegisterAdditionalInfo = lazy(() => import("../pages/customer/services/revenues/addCustomer/step2DataBank/index.js"));
const CustomerRevenuesInsuranceRegistration = lazy(() => import("../pages/customer/services/revenues/addCustomer/InsuranceRegistrationStep2/index.js"));
const CustomerRevenuesRegisterShop = lazy(() => import("../pages/customer/services/revenues/registerShop/index.js"));
const CustomerRevenuesReports = lazy(() => import("../pages/customer/services/revenues/Reports/index.js"));
const CustomerRevenuesRegistrationStore = lazy(() => import("../pages/customer/services/revenues/addCustomer/registration-store/index.js"));
const CustomerRevenuesCalculator = lazy(() => import("../pages/customer/services/revenues/custmerRevenuesCaculator/index.js"));
const InsertComment = lazy(() => import("../pages/customer/services/revenues/InsertComment/index.js"));
const LegalRequestReports = lazy(() => import("../pages/customer/services/revenues/legalRequestReports/index.js"));
const CustomerShopPanelAbout = lazy(() => import("../pages/customer/services/revenues/about/index.js"));

// Customer Loan
const CustomerLoan = lazy(() => import("../pages/customer/loan/index.js"));
const CustomerLoanView = lazy(() => import("../pages/customer/loan/View/index.js"));
const CustomerRequestLoan = lazy(() => import("../pages/customer/loan/requestLoan/index.js"));
const CustomerLoanRequestNoDiamonds = lazy(() => import("../pages/customer/loan/requestLoan/requestLoanNoDiamonds/index.js"));
const CustomerLoanRequestWithDiamonds = lazy(() => import("../pages/customer/loan/requestLoan/requestLoanWithDiamonds/index.js"));
const CustomerLoanShopShopping = lazy(() => import("../pages/customer/loan/shopShopping/index.js"));
const CustomerLoanShopShoppingNewPurchase = lazy(() => import("../pages/customer/loan/shopShopping/newPurchase/index.js"));
const CustomerLoanSellDiamonds = lazy(() => import("../pages/customer/loan/diamonds/sellDiamonds/index.js"));
const CustomerLoanSellDiamondsRequest = lazy(() => import("../pages/customer/loan/diamonds/sellDiamonds/sellDiamondsRequest/index.js"));
const CustomerLoanBuyDiamnods = lazy(() => import("../pages/customer/loan/diamonds/buyDiamonds/index.js"));
const CustomerLoanReturnDiamonds = lazy(() => import("../pages/customer/loan/diamonds/returnDiamonds/index.js"));
const CustomerLoanTransferDiamonds = lazy(() => import("../pages/customer/loan/diamonds/transferDiamonds/index.js"));
const CustomerLoanTransferDiamondsRequests = lazy(() => import("../pages/customer/loan/diamonds/transferDiamonds/transferDiamondsRequest/index.js"));
const CustomerLoanApplicationInvoice = lazy(() => import("../pages/customer/loan/requestLoan/loanApplicationInvoice/index.js"));
const CustomerRequestLoanstoreLoanRules = lazy(() => import("../pages/customer/loan/requestLoan/storeLoanRules/index.js"));
const CustomerLoanBuyDiamondRequest = lazy(() => import("../pages/customer/loan/diamonds/buyDiamonds/request/index.js"));
const CustomerLoanDonationDiamond = lazy(() => import("../pages/customer/loan/diamonds/donationDiamonds/index.js"));
const CustomerLoanDonationDiamondSelectCharity = lazy(() => import("../pages/customer/loan/diamonds/donationDiamonds/selectCharity/index.js"));
const CustomerLoanDonationDiamondSelectCharityDetails = lazy(() => import("../pages/customer/loan/diamonds/donationDiamonds/selectCharity/selectProject/index.js"));
const CustomerLoanDonationDiamondRepots = lazy(() => import("../pages/customer/loan/diamonds/donationDiamonds/donationDiamodsRepots/index.js"));
const CustomerLoanPaymentInstallments = lazy(() => import("../pages/customer/loan/paymentInstallments/index.js"));
const TransferBonPage = lazy(() => import("../pages/customer/loan/transferbBon/index.js"));
const CustomerLoanConvertToBon = lazy(() => import("../pages/customer/loan/diamonds/convertToBon/index.js"));

// Customer Insurance
const CustomerInsurance = lazy(() => import("../pages/customer/insurance/index.js"));
const CustomerBodyInsurance = lazy(() => import("../pages/customer/insurance/bodyInsurance/index.js"));
const CustomerMotorInsurance = lazy(() => import("../pages/customer/insurance/motorInsurance/index.js"));
const CustomerElevatorInsurance = lazy(() => import("../pages/customer/insurance/elevatorInsurance/index.js"));
const CustomerFireInsurance = lazy(() => import("../pages/customer/insurance/fireInsurance/index.js"));
const CustomerResponsibilityInsurance = lazy(() => import("../pages/customer/insurance/responsebilityInsurance/index.js"));
const CustomerThirdInsurance = lazy(() => import("../pages/customer/insurance/thirdInsurance/index.js"));
const CustomerInsuranceIssuseSupport = lazy(() => import("../pages/customer/insurance/elevatorInsuranceIssuseSupport/index.js"));
const CustomerInsurancePaymentDetails = lazy(() => import("../pages/customer/insurance/paymentDetails/index.js"));
const CustomerBuildingInsuranceIssuseSupport = lazy(() => import("../pages/customer/insurance/buildingInsuranceIssuesSupport/index.js"));
const CustomerThirdPartynsuranceIssuseSupport = lazy(() => import("../pages/customer/insurance/thirdPartyInsuranceIssuesSupport/index.js"));
const CustomerBuildingInsurancePaymentDetails = lazy(() => import("../pages/customer/insurance/buildingSelectInsurance/index.js"));
const CuatomerInsuranceThirdPArtyInsuranceSelectInsurance = lazy(() => import("../pages/customer/insurance/thirdPartySelectInsurance/index.js"));
const CuatomerInsuranceThirdPArtyInsuranceSelectInsuranceInsuranceDetails = lazy(() => import("../pages/customer/insurance/thirdPartInusranceDetails/index.js"));

// Customer Shop Panel
const CustomerLoanShopPanel = lazy(() => import("../pages/customer/shopPanel/index.js"));
const CustomerLoanShopPanelRequest = lazy(() => import("../pages/customer/shopPanel/shopPanelRequest/index.js"));
const ShopPanelAbout = lazy(() => import("../pages/customer/shopPanel/shopPanelAbout/index.js"));

// Customer Payment
const BuyDiamondCallback = lazy(() => import("../pages/customer/payment/callback/index.js"));

// Customer Charity
const CharityProjectsPage = lazy(() => import("../pages/customer/legal/charity/project/index.js"));
const InsertCharityProjectPage = lazy(() => import("../pages/customer/legal/charity/project/insert/index.js"));
const CharityProjectCashWithdrawal = lazy(() => import("../pages/customer/legal/charity/project/cashWithdrawal/index.js"));
const ChartilyDiamond = lazy(() => import("../pages/customer/legal/diamonds/index.js"));

// Customer Bon
const BenefitCardHome = lazy(() => import("../pages/customer/bon/index.js"));

// Customer Services
const CustomerServices = lazy(() => import("../pages/customer/services/index.js"));
const CustomerGoldBox = lazy(() => import("../pages/customer/services/goldBox/index.js"));
const CustomerServicesBill = lazy(() => import("../pages/customer/services/bill/index.js"));

// ============================================
// Admin Pages - LAZY
// ============================================
const AdminLogin = lazy(() => import("../pages/admin/Login/index.js"));
const AdminMainPage = lazy(() => import("../pages/admin/mainPage/index.js"));
const AdminDashboard = lazy(() => import("../pages/admin/dashboard/index.js"));

// Admin Marketers
const AdminMarketerPage = lazy(() => import("../pages/admin/marketer/index.js"));
const AdminChangeStatusMarketr = lazy(() => import("../pages/admin/marketer/pages/changeStatusMarketer/index.js"));
const AdminAddNewMarketer = lazy(() => import("../pages/admin/marketer/pages/addNewMarketer/index.js"));
const AdminInformationCustomer = lazy(() => import("../pages/admin/marketer/pages/informationCustomer/index.js"));
const AdminDefaultPlansPage = lazy(() => import("../pages/admin/marketer/pages/defaultPlansPage/index.js"));
const AdminDefaultPlansDetailPage = lazy(() => import("../pages/admin/marketer/pages/defaultPlansPage/pages/createPlan/index.js"));
const AdminDefaultPlansEditPage = lazy(() => import("../pages/admin/marketer/pages/defaultPlansPage/pages/plansEditPage/index.js"));
const AdminAddNewMarketerDetails = lazy(() => import("../pages/admin/marketer/[id]/index.js"));
const AdminMarketersRequestDetails = lazy(() => import("../pages/admin/marketer/[request]/index.js"));

// Admin Customers
const AdminCustomers = lazy(() => import("../pages/admin/customers/index.js"));
const AdminCustomersDetails = lazy(() => import("../pages/admin/customers/pages/customerDetails/index.js"));

// Admin FAQ
const AdminFaq = lazy(() => import("../pages/admin/faq/index.js"));

// Admin Settings
const AdminSettings = lazy(() => import("../pages/admin/settings/index.js"));
const AdminSettingsQuestions = lazy(() => import("../pages/admin/settings/pages/questions/index.js"));
const AdminSettingsRules = lazy(() => import("../pages/admin/settings/pages/rules/index.js"));
const AdminSettingsEducationalVideo = lazy(() => import("../pages/admin/settings/pages/educationalVideo/index.js"));
const AccountDefinition = lazy(() => import("../pages/admin/settings/pages/acountDefinition/index.js"));
const AdminSettingBankList = lazy(() => import("../pages/admin/settings/pages/BankList/index.js"));
const AdminLinkSettings = lazy(() => import("../pages/admin/settings/pages/linkSettings/index.js"));

// Admin Diamonds Panel
const AdminDiamondsPanel = lazy(() => import("../pages/admin/diamondsPanel/index.js"));
const AdminDiamondCompany = lazy(() => import("../pages/admin/diamondsPanel/companyDiamond/index.js"));
const AdminListCompanyDiamonds = lazy(() => import("../pages/admin/diamondsPanel/listCompanyDiamonds/index.js"));

// Admin StreetCard
const AdminStreetCard = lazy(() => import("../pages/admin/streetCard/index.js"));

// Admin Loan
const AdminLoanRequest = lazy(() => import("../pages/admin/loan/index.js"));
const AdminLoanDefinition = lazy(() => import("../pages/admin/loan/DefinitionLoan/index.js"));
const AdminInstallmentCount = lazy(() => import("../pages/admin/loan/installments/index.js"));

// Admin Shop
const AdminShop = lazy(() => import("../pages/admin/shop/index.js"));
const AdminShopNew = lazy(() => import("../pages/admin/shop/newShop/index.js"));
const ShopDetailsPage = lazy(() => import("../pages/admin/shop/[id]/index.js"));

// Admin Insurances
const AdminInsurances = lazy(() => import("../pages/admin/insurances/index.js"));
const AdminInsuranceShowDetails = lazy(() => import("../pages/admin/insurances/[id]/index.js"));

// Admin Legal Users
const AdminLegalUsers = lazy(() => import("../pages/admin/legalUsers/index.js"));
const AdminLegalDetails = lazy(() => import("../pages/admin/legalUsers/[id]/index.js"));
const AdminLegalRequestDetails = lazy(() => import("../pages/admin/legalUsers/details/index.js"));

// Admin Charity
const AdminCustomerCharity = lazy(() => import("../pages/admin/charity/index.js"));
const AdminCharityDetails = lazy(() => import("../pages/admin/charity/[id]/index.js"));

// Admin Excel
const AdminExcelUploadPage = lazy(() => import("../pages/admin/excellUpload/index.js"));


// ============================================
// ROUTES DEFINITIONS - بدون تغییر
// ============================================
const authRoutes = [
  {
    type: "layout",
    key: "auth",
    component: <AuthLayout />,
    children: [
      {
        type: "link",
        name: "auth-signup-not-account",
        key: "auth-signup-not-account",
        route: "/requestCardPage",
        component: <RequestCardPage />
      },
      {
        type: "link",
        name: "SelectRole",
        key: "SelectRole",
        route: "/login",
        component: <SelectRole />
      },
      {
        type: "link",
        name: "signUpOrganizatioal",
        key: "signUpOrganizatioal",
        route: "/signup-oranization",
        component: <SignUpOrganization />
      },
      {
        type: "link",
        name: "LoginOrganizational",
        key: "LoginOrganizational",
        route: "/login-oranization",
        component: <LoginOrganizational />
      },
      {
        type: "link",
        name: "LoginOrganizational",
        key: "LoginOrganizational",
        route: "/login-organization/forget-password",
        component: <ForgetPassword />
      },
      {
        type: "link",
        name: "EnterOtp",
        key: "EnterOtp",
        route: "/enterOtp",
        component: <OtpOrganization />
      },
      {
        type: "link",
        name: "resetPassword",
        key: "resetPassword",
        route: "/resetPassword",
        component: <ResetPassword />
      },
      {
        type: "link",
        name: "signup",
        key: "signup",
        route: "/signup",
        component: <SignUpCustomer />,
      },
      {
        type: "link",
        name: "account-opening",
        key: "account-opening",
        route: "/account-opening",
        component: <AccountOpening />,
      },
    ],
  },
];

const customerRoutes = [
  {
    type: "link",
    name: "plans-list",
    key: "plans-list",
    route: "/customer/profile/plans",
    component: <PlansListPage />,
  },
  {
    type: "link",
    name: "import-excel",
    key: "import-excel",
    route: "/customer/revenues/import-excel",
    component: <CustomerImportCustomerExcelPage />,
  },
  {
    type: "link",
    name: "regulations",
    key: "regulations",
    route: "/regulations",
    component: <Requlations />
  },
  {
    type: "link",
    name: "RevenuesReports",
    key: "RevenuesReports",
    route: "/customer/revenues/reports",
    component: <CustomerRevenuesReports />
  },
  {
    type: "link",
    name: "CustomerRepots",
    key: "CustomerRepots",
    route: "/customer/repots",
    component: <CustomerRepots />
  },
  //TODO
  {
    type: "link",
    name: "Customertransactions",
    key: "Customertransactions",
    route: "/customer/transactions",
    component: <CustomerTransactionsPage />
  },
  {
    type: "link",
    name: "homePage",
    key: "homePage",
    route: "/customer",
    isnav: true,
    isCenter: true,
    component: <MainCustomerPage />,
  },
  {
    type: "link",
    name: "CustomerPos",
    key: "CustomerPos",
    route: "/customer/pos",
    component: <CustomerPos />
  },
  {
    type: "link",
    name: "customer/pos/change-pos",
    key: "customer/pos/change-pos",
    route: "/customer/pos/change-pos",
    component: <ChangePosPage />
  },
  {
    type: "link",
    name: "CustomerPosForm",
    key: "CustomerPosForm",
    route: "/customer/pos/form",
    component: <CustomerPosForm />
  },
  {
    type: "link",
    name: "customerPosDeviceSelect",
    key: "customerPosDeviceSelect",
    route: "/customer/pos/form/device-select",
    component: <CustomerPosDeviceSelect />
  },
  {
    isnav: true,
    isCenter: false,
    label: "پروفایل",
    type: "link",
    name: "profile",
    key: "profile",
    route: "/customer/profile",
    component: <CustomerProfile />,
  },
  {
    isnav: true,
    isCenter: false,
    label: "تغییر پسورد",
    type: "link",
    name: "change-password",
    key: "change-password",
    route: "/customer/profile/change-password",
    component: <ChangePassword />,
  },
  {
    type: "link",
    name: "editeProfile",
    key: "editeProfile",
    route: "/customer/profile/editeProfile",
    component: <CustomerEditeProfile />,
  },
  {
    type: "link",
    name: "customerProfileTeach",
    key: "customerProfileTeach",
    route: "/customer/profile/teach",
    component: <CustomerProfileTeach />
  },
  {
    isnav: false,
    isCenter: false,
    label: "",
    icon: "",
    type: "link",
    name: "Rule",
    key: "Rule",
    route: "/customer/profile/rules",
    component: <CustomerRule />,
  },
  {
    isnav: false,
    isCenter: false,
    label: "",
    icon: "",
    type: "link",
    name: "About",
    key: "About",
    route: "/customer/profile/about",
    component: <CustomerAbouteUs />,
  },
  {
    isnav: false,
    isCenter: false,
    label: "",
    icon: "",
    type: "link",
    name: "Questions",
    key: "Questions",
    route: "/customer/profile/questions",
    component: <CustomerQuestions />,
  },
  {
    type: "link",
    name: "CustomerRevenues",
    key: "CustomerRevenues",
    route: "/customer/revenues",
    component: <CustomerRevenues />,
  },
  {
    type: "link",
    name: "customer/revenues/legal-request-reports",
    key: "customer/revenues/legal-request-reports",
    route: "/customer/revenues/legal-request-reports",
    component: <LegalRequestReports />,
  },
  {
    type: "link",
    name: "customer-revenues-calculater",
    key: "customer-revenues-calculater",
    route: "/customer/revenues/calculator",
    component: <CustomerRevenuesCalculator />
  },
  {
    type: "link",
    name: "CustomerRevenuesCustomerReports",
    key: "CustomerRevenuesCustomerReports",
    route: "/customer/revenues/customer-reports/:customerId",
    component: <CustomerRevenuesCustomerReports />,
  },
  {
    type: "link",
    name: "customer-revenues-addcustomer-registration-store",
    key: "customer-revenues-addcustomer-registration-store",
    route: "/customer/revenues/add-customer/registration-store",
    component: <CustomerRevenuesRegistrationStore />
  },
  {
    type: "link",
    name: "CustomerRevenuesRegisterMarketerRequest",
    key: "CustomerRevenuesRegisterMarketerRequest",
    route: "/customer/revenues/register-marketer",
    component: <CustomerRevenuesRegisterMarketerRequest />,
  },
  {
    type: "link",
    name: "CustomerRevenuesRegisterAdditionalInfo",
    key: "CustomerRevenuesRegisterAdditionalInfo",
    route: "/customer/revenues/register-marketer/additional-info",
    component: <CustomerRevenuesRegisterAdditionalInfo />,
  },
  {
    type: "link",
    name: "CustomerReversition",
    key: "CustomerReservition",
    route: "/customer/revenues/register-marketer/visitor-request",
    component: <CustomerRevenuesRegisterVisitorRequest />
  },
  {
    type: "link",
    name: "CustomerRevenuesAddCustomerBanking",
    key: "CustomerRevenuesAddCustomerBanking",
    route: "/customer/revenues/add-customer",
    component: <CustomerRevenuesAddCustomerBanking />,
  },
  {
    type: "link",
    name: "CustomerRevenuesAddCustomerBankingadditional",
    key: "CustomerRevenuesAddCustomerBankingadditional",
    route: "/customer/revenues/add-customer/additional-info",
    component: <CustomerRevenuesRegisterAdditionalInfoBanking />,
  },
  {
    type: "link",
    name: "insertComment",
    key: "insertComment",
    route: "/customer/revenues/insertComment/:id",
    component: <InsertComment />,
  },
  {
    type: "link",
    name: "customer-revenuse-add-customer-data-type-insurance",
    key: "customer-revenuse-add-customer-data-type-insurance",
    route: "/customer/revenues/add-customer/insurance-type",
    component: <CustomerRevenuesInsuranceRegistration />
  },
  {
    type: "link",
    name: "customer-loan",
    key: "customer-loan",
    route: "/customer/loan",
    component: <CustomerLoan />
  },
  {
    type: "link",
    name: "customer-loan",
    key: "customer-loan",
    route: "/customer/benefit",
    component: <BenefitCardHome />
  },
  {
    type: "link",
    name: "customer-loan",
    key: "customer-loan",
    route: "/customer/loan/transfer-loan",
    component: <TransferBonPage />
  },
  {
    type: "link",
    name: "customer-loan",
    key: "customer-loan",
    route: "/customer/loan/convert-bon",
    component: <CustomerLoanConvertToBon />
  },
  {
    type: "link",
    name: "customer-loan-payment-installmetns",
    key: "customer-loan-payment-installmetns",
    route: "/customer/loan/payments-installments",
    component: <CustomerLoanPaymentInstallments />
  },
  {
    type: "link",
    name: "CustomerServices",
    key: "CustomerServices",
    route: "/customer/services",
    component: <CustomerServices />
  },
  {
    type: "link",
    name: "CustomerServicesGoldBox",
    key: "CustomerServicesGoldBox",
    route: "/customer/services/gold-box",
    component: <CustomerGoldBox />
  },
  {
    type: "link",
    name: "CustomerServicesBill",
    key: "CustomerServicesBill",
    route: "/customer/services/bill",
    component: <CustomerServicesBill />
  },
  {
    type: "link",
    name: "CustomerInsurance",
    key: "CustomerInsurance",
    route: "/customer/services/insurance",
    component: <CustomerInsurance />,
  },
  {
    type: "link",
    name: "CustomerInsuranceIssuseSupport",
    key: "CustomerInsuranceIssuseSupport",
    route: "/customer/insurance/elevator/support",
    component: <CustomerInsuranceIssuseSupport />,
  },
  {
    type: "link",
    name: "CustomerInsuranceThirdInsurancesPaymentDetils",
    key: "CustomerInsuranceThirdInsurancesPaymentDetils",
    route: "/customer/insurance/building-insurance/support",
    component: <CustomerBuildingInsuranceIssuseSupport />,
  },
  {
    type: "link",
    name: "CustomerInsuranceThirdInsurancesIssues",
    key: "CustomerInsuranceThirdInsurancesIssues",
    route: "/customer/insurance/third-insurance/support",
    component: <CustomerThirdPartynsuranceIssuseSupport />,
  },
  {
    type: "link",
    name: "CustomerInsuranceThirdInsuranceSelectInsurance",
    key: "CustomerInsuranceThirdInsuranceSelectInsurance",
    route: "/customer/insurance/third-insurance/select-insurance",
    component: <CuatomerInsuranceThirdPArtyInsuranceSelectInsurance />,
  },
  {
    type: "link",
    name: "CustomerInsuranceThirdInsuranceSelectInsuranceInsuranceDetails",
    key: "CustomerInsuranceThirdInsuranceSelectInsuranceInsuranceDetails",
    route: "/customer/insurance/third-insurance/select-insurance/insurance-detail",
    component: <CuatomerInsuranceThirdPArtyInsuranceSelectInsuranceInsuranceDetails />,
  },
  {
    type: "link",
    name: "CustomerInsurancePaymentDetails",
    key: "CustomerInsurancePaymentDetails",
    route: "/customer/insurance/elevator/select-insurance",
    component: <CustomerInsurancePaymentDetails />,
  },
  {
    type: "link",
    name: "CustomerInsurancePaymentDetails",
    key: "CustomerInsurancePaymentDetails",
    route: "/customer/insurance/building-insurance/select-insurance",
    component: <CustomerBuildingInsurancePaymentDetails />,
  },
  {
    type: "link",
    name: "CustomerElevatorInsuranceAddElevator",
    key: "CustomerElevatorInsuranceAddElevator",
    route: "customer/insurance/elevator-insurance/add-elevator",
    component: <CustomerElevatorInsurance />,
  },
  {
    type: "link",
    name: "CustomerBodyInsurance",
    key: "CustomerBodyInsurance",
    route: "/customer/insurance/body-insurance",
    component: <CustomerBodyInsurance />,
  },
  {
    type: "link",
    name: "CustomerMotorInsurance",
    key: "CustomerMotorInsurance",
    route: "/customer/insurance/motor-insurance",
    component: <CustomerMotorInsurance />,
  },
  {
    type: "link",
    name: "CustomerRevenuesSubmitShop",
    key: "CustomerRevenuesSubmitShop",
    route: "/customer/revenues/data-shop",
    component: <CustomerRevenuesRegisterShop />,
  },
  {
    type: "link",
    name: "CustomerElevatorInsurance",
    key: "CustomerElevatorInsurance",
    route: "/customer/insurance/elevator-insurance",
    component: <CustomerElevatorInsurance />,
  },
  {
    type: "link",
    name: "CustomerFireInsurance",
    key: "CustomerFireInsurance",
    route: "/customer/insurance/fire-insurance",
    component: <CustomerFireInsurance />,
  },
  {
    type: "link",
    name: "CustomerResponsbilityInsurance",
    key: "CustomerResponsbilityInsurance",
    route: "/customer/insurance/responsebility-insurance",
    component: <CustomerResponsibilityInsurance />,
  },
  {
    type: "link",
    name: "CustomerThirdInsurance",
    key: "CustomerThirdInsurance",
    route: "/customer/insurance/third-insurance",
    component: <CustomerThirdInsurance />,
  },
  {
    type: "link",
    name: "customer-loan-view",
    key: "customer-loan-view",
    route: "/customer/loan/view",
    component: <CustomerLoanView />
  },
  {
    type: "link",
    name: "customer-loan-request",
    key: "customer-loan-request",
    route: "/customer/loan/request",
    component: <CustomerRequestLoan />
  },
  {
    type: "link",
    name: "customer-loan-request-no-diamonds",
    key: "customer-loan-request-no-diamonds",
    route: "/customer/loan/request/no-diamonds",
    component: <CustomerLoanRequestNoDiamonds />
  },
  {
    type: "link",
    name: "customer-loan-request-no-diamonds-Invoice",
    key: "customer-loan-request-no-diamonds-Invoice",
    route: "/customer/loan/request/no-diamonds/invoice",
    component: <CustomerLoanApplicationInvoice />
  },
  {
    type: "link",
    name: "customer-loan-request-no-diamonds-rules",
    key: "customer-loan-request-no-diamonds-rules",
    route: "/customer/loan/request/no-diamonds/rules",
    component: <CustomerRequestLoanstoreLoanRules />
  },
  {
    type: "link",
    name: "customer-loan-request-with-diamonds",
    key: "customer-loan-request-with-diamonds",
    route: "/customer/loan/request/with-diamonds",
    component: <CustomerLoanRequestWithDiamonds />
  },
  {
    type: "link",
    name: "customer-loan-return-diamonds",
    key: "customer-loan-return-diamonds",
    route: "/customer/loan/return-diamond",
    component: <CustomerLoanReturnDiamonds />
  },
  {
    type: "link",
    name: "customer-loan-donation-diamond",
    key: "customer-loan-donation-diamond",
    route: "/customer/loan/donation-diamond",
    component: <CustomerLoanDonationDiamond />
  },
  {
    type: "link",
    name: "cutomer-loan-donation-diamond",
    key: "customer-loan-donation-diamond",
    route: "/customer/loan/donation-diamond/my-repots",
    component: <CustomerLoanDonationDiamondRepots />
  },
  {
    type: "link",
    name: "customer-loan-donation-diamond-select-charity",
    key: "customer-loan-donation-diamond-select-charity",
    route: "/customer/loan/donation-diamond/select-charity",
    component: <CustomerLoanDonationDiamondSelectCharity />
  },
  {
    type: "link",
    name: "customer-loan-donation-diamond-select-charity-details",
    key: "customer-loan-donation-diamond-select-charity-details",
    route: "/customer/loan/donation-diamond/:id",
    component: <CustomerLoanDonationDiamondSelectCharityDetails />
  },
  {
    type: "link",
    name: "customer-loan-transfer-diamonds",
    key: "customer-loan-transfer-diamonds",
    route: "/customer/loan/transfer-diamonds",
    component: <CustomerLoanTransferDiamonds />
  },
  {
    type: "link",
    name: "customer-loan-transfer-diamonds-requests",
    key: "customer-loan-transfer-diamonds-requests",
    route: "/customer/loan/transfer-diamonds/request",
    component: <CustomerLoanTransferDiamondsRequests />
  },
  {
    type: "link",
    name: "customer-loan-shopShopping",
    key: "customer-loan-shopShopping",
    route: "/customer/loan/shop-shopping",
    component: <CustomerLoanShopShopping />
  },
  {
    type: "link",
    name: "customer-loan-shopShopping-newPurchase",
    key: "customer-loan-shopShopping-newPurchase",
    route: "/customer/loan/shop-Shopping/new-purchase",
    component: <CustomerLoanShopShoppingNewPurchase />
  },
  {
    type: "link",
    name: "customer-loan-ShopPanel",
    key: "customer-loan-ShopPanel",
    route: "/customer/shop-panel",
    component: <CustomerLoanShopPanel />
  },
  {
    type: "link",
    name: "customer-shop-pannel-about",
    key: "customer-shop-pannel-about",
    route: "/customer/revenues/register-marketer/about",
    component: <CustomerShopPanelAbout />
  },
  {
    type: "link",
    name: "customer-shop-pannel-about",
    key: "customer-shop-pannel-about",
    route: "/customer/shop-panel/about",
    component: <ShopPanelAbout />
  },
  {
    type: "link",
    name: "customer-loan-ShopPanel-request",
    key: "customer-loan-ShopPanel-request",
    route: "/customer/shop-panel/request",
    component: <CustomerLoanShopPanelRequest />
  },
  {
    type: "link",
    name: "customer-loan-sell-diamond",
    key: "customer-loan-sell-diamond",
    route: "/customer/loan/convert-to-rial",
    component: <CustomerLoanSellDiamonds />
  },
  {
    type: "link",
    name: "customer-loan-sell-diamonds-request",
    key: "customer-loan-sell-diamonds-request",
    route: "/customer/loan/sell-diamond/request",
    component: <CustomerLoanSellDiamondsRequest />
  },
  {
    type: "link",
    name: "customer-loan-buy-diamonds",
    key: "customer-loan-buy-diamonds",
    route: "/customer/loan/buy-diamond",
    component: <CustomerLoanBuyDiamnods />
  },
  {
    type: "link",
    name: "customer-loan-buy-diamonds-page",
    key: "customer-loan-buy-diamonds-page",
    route: "/customer/loan/buy-diamond/request",
    component: <CustomerLoanBuyDiamondRequest />
  },
  {
    type: "link",
    name: "financeDeposit",
    key: "financeDeposit",
    route: "/customer/payment/callback",
    component: <BuyDiamondCallback />,
  },
  {
    type: "link",
    name: "customer-request-card-pill",
    key: "customer-request-card-pill",
    route: "/customer/pill",
    component: <CustomerCardRequestPill />
  },
  {
    type: "link",
    name: "customer-request-card-game",
    key: "customer-request-card-game",
    route: "/customer/games",
    component: <CustomerCardRequestGame />
  },
  {
    type: "link",
    name: "customer-request-card-IncomeGeneration",
    key: "customer-request-card-IncomeGeneration",
    route: "/customer/incom-eneration",
    component: <CustomerCardRequestIncomeGeneration />
  },
  {
    type: "link",
    name: "customer-request-card-pill-paymentId",
    key: "customer-request-card-pill-paymentId",
    route: "/customer/pill/paymentId",
    component: <CustomerCardRequesPillpaymentId />
  },
  {
    type: "link",
    name: "customer-request-card-pill-payment-buy",
    key: "customer-request-card-pill-payment-buy",
    route: "/customer/pill/paymentBuy",
    component: <CustomerCardRequestPaymaneBuy />
  },
  {
    type: "link",
    name: "customer-charity-project",
    key: "customer-charity-project",
    route: "/customer/legal/charity/project",
    component: <CharityProjectsPage />
  },
  {
    type: "link",
    name: "customer-charity-project-cashWithdrawal",
    key: "customer-charity-project-cashWithdrawal",
    route: "/customer/legal/charity/project/cash-withdrawal",
    component: <CharityProjectCashWithdrawal />
  },
  {
    type: "link",
    name: "charity-project-insert",
    key: "charity-project-insert",
    route: "/customer/legal/charity/project/insert",
    component: <InsertCharityProjectPage />
  },
  {
    type: "link",
    name: "customer-legal-charity-diamonds",
    key: "customer-legal-charity-diamonds",
    route: "/customer/legal/charity/diamonds",
    component: <ChartilyDiamond />
  },
];

const ownerRoutes = [
  {}
];

const adminRoutes = [
  {
    type: "link",
    name: "Admin-Login",
    key: "Admin-Login",
    route: "/admin/login",
    component: <AdminLogin />
  },
  {
    type: "link",
    name: "admin-legal-users-details",
    key: "admin-legal-users-details",
    route: "/admin/legal-users/details",
    component: <AdminLegalRequestDetails />
  },
  {
    type: "link",
    name: "Admin-Insurances",
    key: "Admin-Insurances",
    route: "/admin/insurances",
    component: <AdminInsurances />
  },
  {
    type: "link",
    name: "Admin-Insurances-details",
    key: "Admin-Insurances-details",
    route: "/admin/insurances/:insuranceid",
    component: <AdminInsuranceShowDetails />
  },
  {
    type: "link",
    name: "homePage",
    key: "homePage",
    route: "/admin",
    isnav: true,
    isCenter: true,
    component: <AdminMainPage />,
  },
  {
    type: "link",
    name: "marketer",
    key: "marketer",
    route: "/admin/marketers",
    isnav: true,
    isCenter: true,
    component: <AdminMarketerPage />,
  },
  {
    type: "link",
    name: "marketer",
    key: "marketer",
    route: "/admin/marketers/:visitorId",
    isnav: true,
    isCenter: true,
    component: <AdminAddNewMarketerDetails />,
  },
  {
    type: "link",
    name: "marketerRequest",
    key: "marketerRequest",
    route: "/admin/marketers/request/:id",
    component: <AdminMarketersRequestDetails />
  },
  {
    type: "link",
    name: "marketer-change-status",
    key: "marketer-change-status",
    route: "/admin/marketers/change-status/:id",
    isnav: true,
    isCenter: true,
    component: <AdminChangeStatusMarketr />,
  },
  {
    type: "link",
    name: "marketer-AddNewMarketer",
    key: "marketer-AddNewMarketer",
    route: "/admin/marketers/new",
    isnav: true,
    isCenter: true,
    component: <AdminAddNewMarketer />,
  },
  {
    type: "link",
    name: "marketer-customers",
    key: "marketer-customers",
    route: "/admin/marketers/customers/:id",
    isnav: true,
    isCenter: true,
    component: <AdminInformationCustomer />,
  },
  {
    type: "link",
    name: "default-plans",
    key: "default-plans",
    route: "/admin/marketers/default-plans",
    isnav: true,
    isCenter: true,
    component: <AdminDefaultPlansPage />,
  },
  {
    type: "link",
    name: "default-plans",
    key: "default-plans",
    route: "/admin/marketers/default-plans/edit/:id",
    isnav: true,
    isCenter: true,
    component: <AdminDefaultPlansEditPage />,
  },
  {
    type: "link",
    name: "admin/dashboard",
    key: "admin/dashboard",
    route: "/admin/dashboard",
    isnav: true,
    isCenter: true,
    component: <AdminDashboard />,
  },
  {
    type: "link",
    name: "default-plans/new",
    key: "default-plans/new",
    route: "/admin/marketers/default-plans/new",
    isnav: true,
    isCenter: true,
    component: <AdminDefaultPlansDetailPage />,
  },
  {
    type: "link",
    name: "default-plans/new",
    key: "default-plans/new",
    route: "/admin/change-password",
    isnav: true,
    isCenter: true,
    component: <ChangeAdminPasswordPage />,
  },
  {
    type: "link",
    name: "customers",
    key: "customers",
    route: "/admin/customers",
    isnav: true,
    isCenter: true,
    component: <AdminCustomers />,
  },
  {
    type: "link",
    name: "excelUpload",
    key: "excelUpload",
    route: "/admin/excelUpload",
    isnav: true,
    isCenter: true,
    component: <AdminExcelUploadPage />,
  },
  {
    type: "link",
    name: "excelUpload-list",
    key: "excelUpload-list",
    route: "/admin/excelUploads/list",
    isnav: true,
    isCenter: true,
    component: <ExcelFileListPage />,
  },
  {
    type: "link",
    name: "customers",
    key: "customers",
    route: "/admin/customers/:id",
    isnav: true,
    isCenter: true,
    component: <AdminCustomersDetails />,
  },
  {
    type: "link",
    name: "faq",
    key: "faq",
    route: "/admin/faq",
    isnav: true,
    isCenter: true,
    component: <AdminFaq />,
  },
  {
    type: "link",
    name: "admin-settings",
    key: "admin-setting",
    route: "/admin/settings",
    component: <AdminSettings />
  },
  {
    type: "link",
    name: "admin-settings",
    key: "admin-setting",
    route: "/admin/settings/link-settings",
    component: <AdminLinkSettings />
  },
  {
    type: "link",
    name: "admin-settings-questions",
    key: "admin-settings-questions",
    route: "/admin/settings/questions",
    component: <AdminSettingsQuestions />
  },
  {
    type: "link",
    name: "admin-settings-rules",
    key: "admin-settings-rules",
    route: "/admin/settings/rules",
    component: <AdminSettingsRules />
  },
  {
    type: "link",
    name: "admin-setting-edicationVideo",
    key: "admin-setting-edicationVideo",
    route: "/admin/settings/educational-video",
    component: <AdminSettingsEducationalVideo />
  },
  {
    type: "link",
    name: "admin-setting-account-definition",
    key: "admin-setting-account-definition",
    route: "/admin/settings/account-definition",
    component: <AccountDefinition />
  },
  {
    type: "link",
    name: "admin-settings-bank-list",
    key: "admin-settings-bank-list",
    route: "/admin/settings/bank-list",
    component: <AdminSettingBankList />
  },
  {
    type: "link",
    name: "Admin-StreetCard",
    key: "Admin-StreetCard",
    route: "/admin/street-carts",
    component: <AdminStreetCard />
  },
  {
    type: "link",
    name: "Admin-Diamonds-Panel",
    key: "Admin-Diamonds-Panel",
    route: "/admin/diamonds-panel",
    component: <AdminDiamondsPanel />
  },
  {
    type: "link",
    name: "Admin-Company-Dimamond",
    key: "Admin-Company-Dimamond",
    route: "/admin/company-diamonds",
    component: <AdminDiamondCompany />
  },
  {
    type: "link",
    name: "Admin-list-company-diamonds",
    key: "Admin-list-company-diamonds",
    route: "/admin/list-company-diamonds",
    component: <AdminListCompanyDiamonds />
  },
  {
    type: "link",
    name: "admin-loan-request",
    key: "admin-loan-request",
    route: "/admin/loan-request",
    component: <AdminLoanRequest />
  },
  {
    type: "link",
    name: "admin-loan-definition",
    key: "admin-loan-definition",
    route: "/admin/loan-definition",
    component: <AdminLoanDefinition />
  },
  {
    type: "link",
    name: "admin-loan-installments",
    key: "admin-loan-installments",
    route: "/admin/loan-installments",
    component: <AdminInstallmentCount />
  },
  {
    type: "link",
    name: "admin-shop",
    key: "admin-shop",
    route: "/admin/shop",
    component: <AdminShop />
  },
  {
    type: "link",
    name: "admin-shop",
    key: "admin-shop",
    route: "/admin/shop/:id",
    component: <ShopDetailsPage />
  },
  {
    type: "link",
    name: "admin-shop-new",
    key: "admin-shop-new",
    route: "/admin/shop/new",
    component: <AdminShopNew />
  },
  {
    type: "link",
    name: "admin-legal-users",
    key: "admin-legal-users",
    route: "/admin/legal-users",
    component: <AdminLegalUsers />
  },
  {
    type: "link",
    name: "admin-legal-users",
    key: "admin-legal-users",
    route: "/admin/legal-users/:id",
    component: <AdminLegalDetails />
  },
  {
    type: "link",
    name: "admin-charity",
    key: "",
    route: "/admin/charity",
    component: <AdminCustomerCharity />
  },
  {
    type: "link",
    name: "admin-charity-details",
    key: "admin-charity-details",
    route: "/admin/charity/:charityId",
    component: <AdminCharityDetails />
  }
];

const buildMainRoutes = (roleRoutes: any[]) => ({
  type: "layout",
  key: "main",
  component: <MainLayout />,
  children: roleRoutes,
});

const buildOwnerRoutes = (roleRoutes: any[]) => ({
  type: "layout",
  key: "main",
  component: <OwnerLayout />,
  children: roleRoutes,
});

const buildAdminRoutes = (roleRoutes: any[]) => ({
  type: "layout",
  key: "main",
  component: <AdminLayout />,
  children: roleRoutes,
});

const routesByRole: Record<userRoleCartStreet, any[]> = {
  customer: [...authRoutes, buildMainRoutes(customerRoutes)],
  legal: [...authRoutes, buildOwnerRoutes(ownerRoutes)],
  admin: [...authRoutes, buildAdminRoutes(adminRoutes)],
  preCustomer: []
};

const routes: any[] = [
  ...authRoutes,
  buildMainRoutes(customerRoutes),
  buildOwnerRoutes(ownerRoutes),
  buildAdminRoutes(adminRoutes),
];

export const getRoutesByRole = (role: userRoleCartStreet) => routesByRole[role];

export {
  authRoutes,
  customerRoutes,
  ownerRoutes,
  adminRoutes,
};

export default routes;